import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../../Configuration/configuration.service';
import { LocalStorageService } from '../../../../Shared/common/local-storage.service';
import { CharityDataShareServiceService } from '../../charities/services/charity-data-share-service.service';
import { Notes2 } from '../models/notes2';
import { Note3model } from '../models/note3model';
import { Note7model } from '../models/note7model';
import { Note4model } from '../models/note4model';
import { SelectedNotesmodel } from '../models/selected-notesmodel';
import { Note24model } from '../models/note24model';
import { Note19model } from '../models/note19model';
import { Note5 } from '../models/note5';
import { Note10model } from '../models/note10model';
import { Note12model } from '../models/note12model';
import { Note27model } from '../models/note27model';
import { CurrencyResponse } from '../models/countryCurrencymodel';
import { Note17Model } from '../../../../Data/Models/note17-model';
import { SecondTabNote17 } from '../../../../Data/Models/second-tab-note17';
import { BreakdownofCurrent } from '../../../../Data/Models/breakdownof-current';
import { Notes27page3 } from '../models/notes27page3';
import { Note30model } from '../note30/Note30model';

@Injectable({
  providedIn: 'root'
})

export class NotesApiService {
  SaveNote18FormModel: any;
  constructor(private http: HttpClient, private configService: ConfigurationService, private dataShareService: CharityDataShareServiceService, private lsService: LocalStorageService) { }
  private apiUrl = this.configService.getAPIBaseUrl(); // Base URL for your API
  private currencyApiUrl = 'https://custom-api-6028.azurewebsites.net/api/CurrencyandTimezone/GetCountryCurrency';

  //headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  saveSelectedNotesDetails(SelectedNotes: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveSelectedNotesDetails`;
    return this.http.post<SelectedNotesmodel>(url, SelectedNotes);
  }
  GetSelectedNotesDetails(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetSelectedNotesDetails?id=`;
    return this.http.get(url + id);
  }
  saveNote3Details(Note3details: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNote3Details`;
    return this.http.post<Note3model>(url, Note3details);
  }
  CharityDetails(CharityId: any): Observable<any> {

    const url = `${this.apiUrl}/CharityDetails/EditCharityDetails?CharityId=`;
    return this.http.get(url + CharityId);
  }

  SaveNotes6(note6Modal: any[]): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes6`;
    return this.http.post<any>(url, note6Modal);
  }
  SaveNotes17(note17Modal: any[]): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes17`;
    return this.http.post<any>(url, note17Modal);
  }
  SaveNotesSecondTab17(note17Modal: any[]): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SecondTabSaveNotes17`;
    return this.http.post<any>(url, note17Modal);
  }

  SaveNotesfourthTab17(note17Modal: any[]): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/BreakdownofCurrentAssetInvestmentSaveNotes17`;
    return this.http.post<any>(url, note17Modal);
  }

  GetNotes17(financialPeriodsID: string): Observable<Note17Model[]> {
    const url = `${this.apiUrl}/Note11to20/GetNotes17?financialPeriodsID=`;
    return this.http.get<Note17Model[]>(url + financialPeriodsID);
  }
  SecondTabGetNotes17(financialPeriodsID: any): Observable<SecondTabNote17[]> {

    const url = `${this.apiUrl}/Note11to20/SecondTabGetNote17Details?financialPeriodsID=`;
    return this.http.get<SecondTabNote17[]>(url + financialPeriodsID);
  }

  BreakdownofCurrentAssetGetNotes17(financialPeriodsID: any): Observable<BreakdownofCurrent[]> {

    const url = `${this.apiUrl}/Note11to20/BreakdownofCurrentAssetGetNote17Details?financialPeriodsID=`;
    return this.http.get<BreakdownofCurrent[]>(url + financialPeriodsID);
  }

  GetNotes6(financialPeriodsID: string): Observable<any> {
    //const url = `${this.apiUrl}/Note1to10/GetNotes6?FinancialPeriodsID=${financialPeriodsID}&TabType=${encodeURIComponent(tabType)}`;
    const url = `${this.apiUrl}/Note1to10/GetNotes6?financialPeriodsID=`;
    return this.http.get<any>(url + financialPeriodsID);
  }
  //saveNote4Details(Note4details: any): Observable<any> {
  //  
  //  const url = `${this.apiUrl}/Note1to10/SaveNote4Details`;
  //  return this.http.post<Note4model>(url, Note4details);
  //}
  saveNote4Details(Note4details: any, action: string): Observable<any> {


    const charityID = +localStorage.getItem('currentCharityID')!;
    const url = `${this.apiUrl}/Note1to10/SaveNote4Details?charityID=${charityID}&action=${action}`;

    return this.http.post<Note4model>(url, Note4details);
  }
  GetNote3Details(Note: any): Observable<any> {

    const payload = {
      userId: localStorage.getItem('CurrentuserID'),
      centralUserId: localStorage.getItem('CentralUserId'),
      financialPeriodsID: localStorage.getItem('currentPeriod'),
      note: Note
    }
    const url = `${this.apiUrl}/Note1to10/GetNote3Details`;
    return this.http.post<Note3model>(url, payload);
  }
  GetNote4Details(): Observable<any> {
    const payload = {
      financialPeriodsID: localStorage.getItem('currentPeriod'),

    }
    const url = `${this.apiUrl}/Note1to10/GetNote4Details`
    return this.http.post<Note4model>(url, payload)
  }
  GetSofaDetails(): Observable<any> {

    const payload = {
      userId: localStorage.getItem('CurrentuserID'),
      centralUserId: localStorage.getItem('CentralUserId'),
      id: localStorage.getItem('currentPeriod'),
    }
    const url = `${this.apiUrl}/Note1to10/GetSofaDetails`;
    return this.http.post<Note3model>(url, payload);
  }

  SaveNotes2(notes2: Notes2): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes2`;
    return this.http.post<any>(url, notes2);
  }
  SaveNotes2BasisofPreparation(notes2BasisofPreparation: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes2BasisofPreparation`;
    return this.http.post<any>(url, notes2BasisofPreparation);
  }
  SaveNotes2GoingConcern(notes2GoingConcern: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes2GoingConcern`;
    return this.http.post<any>(url, notes2GoingConcern);
  }
  SaveNotes2ChangeofAccountingPolicy(notes2ChangeofAccountingPolicy: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes2ChangeofAccountingPolicy`;
    return this.http.post<any>(url, notes2ChangeofAccountingPolicy);
  }
  SaveNotes2ChangestoAccountingEstimates(notes2ChangestoAccountingEstimates: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes2ChangestoAccountingEstimates`;
    return this.http.post<any>(url, notes2ChangestoAccountingEstimates);
  }
  SaveNotes2MaterialPriorYearErrors(notes2MaterialPriorYearErrors: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes2MaterialPriorYearErrors`;
    return this.http.post<any>(url, notes2MaterialPriorYearErrors);
  }
  SaveNotes2Reconciliationaccountingpractice(notes2Reconciliationaccountingpractice: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes2Reconciliationaccountingpractice`;
    return this.http.post<any>(url, notes2Reconciliationaccountingpractice);
  }
  SaveNotes2Income(notes2Income: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes2Income`;
    return this.http.post<any>(url, notes2Income);
  }
  SaveNotes2ExpenditureandLiabilities(notes2ExpenditureandLiabilities: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes2ExpenditureandLiabilities`;
    return this.http.post<any>(url, notes2ExpenditureandLiabilities);
  }
  SaveNotes2Assets(notes2Assets: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes2Assets`;
    return this.http.post<any>(url, notes2Assets);
  }

  SaveNotes12(Note12model: any): Observable<any> {

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.apiUrl}/Note11to20/SaveNotes12`;
    return this.http.post<Note12model>(url, [Note12model], { headers });
  }

  GetNote12Details(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNotes12?id=`;
    return this.http.get(url + id);
  }

  GetNote18ModelA(id: any, charityID: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNotes18A?id=${id}&CharityID=${charityID}`;
    return this.http.get(url);
  }



  SaveNote18Model(id: any, payload: any): Observable<any> {
    const url = `${this.apiUrl}/Note11to20/SaveNotes18A?id=${id}`;
    return this.http.post(url, payload);
  }
  SaveNotes18B(id: any, payload: any): Observable<any> {
    const url = `${this.apiUrl}/Note11to20/SaveNotes18B?id=${id}`;
    return this.http.post(url, payload);
  }


  GetNotes18B(id: any): Observable<any> {
    const url = `${this.apiUrl}/Note11to20/GetNotes18B?id=${id}`;
    return this.http.get(url);
  }



  GetNote2Details(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote2Details?id=`;
    return this.http.get(url + id);
  }
  GetNote2BasisofPreparation(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote2BasisofPreparation?id=`;
    return this.http.get(url + id);
  }
  GetNote2GoingConcern(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote2GoingConcern?id=`;
    return this.http.get(url + id);
  }
  GetNote2ChangeofAccountingPolicy(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote2ChangeofAccountingPolicy?id=`;
    return this.http.get(url + id);
  }
  GetNote2ChangestoAccountingEstimates(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote2ChangestoAccountingEstimates?id=`;
    return this.http.get(url + id);
  }
  GetNote2MaterialPriorYearErrors(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote2MaterialPriorYearErrors?id=`;
    return this.http.get(url + id);
  }
  GetNote2Reconciliationaccountingpractice(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote2Reconciliationaccountingpractice?id=`;
    return this.http.get(url + id);
  }
  GetNote2Income(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote2Income?id=`;
    return this.http.get(url + id);
  }
  GetNote2ExpenditureandLiabilities(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote2ExpenditureandLiabilities?id=`;
    return this.http.get(url + id);
  }
  GetNote2Assets(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote2Assets?id=`;
    return this.http.get(url + id);
  }
  deleteNote2wizard1(id: any): Observable<any> {
    const url = `${this.apiUrl}/Note1to10/deleteNote2wizard1?id=${id}`;
    return this.http.delete(url);
  }
  deleteNote2wizard2(id: any): Observable<any> {
    const url = `${this.apiUrl}/Note1to10/deleteNote2wizard2?id=${id}`;
    return this.http.delete(url);
  }
  deleteNote2wizard3(id: any): Observable<any> {
    const url = `${this.apiUrl}/Note1to10/deleteNote2wizard3?id=${id}`;
    return this.http.delete(url);
  }
  deleteNote2wizard4(id: any): Observable<any> {
    const url = `${this.apiUrl}/Note1to10/deleteNote2wizard4?id=${id}`;
    return this.http.delete(url);
  }

  saveNote5(note5Data: Note5): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes5`;
    return this.http.post<any>(url, note5Data);
  }
  GetNote5Details(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote5Details?id=`;
    return this.http.get(url + id);
  }


  DeleteNotes6(financialPeriodsID: any, TabType: any, Id: any) {debugger
    const payload = {
      financialPeriodsID: financialPeriodsID,
      Id: Id?.toString(),
      TabType: TabType?.toString()
    }
    const url = `${this.apiUrl}/Note1to10/DeleteNotes6`;
    return this.http.post(url, payload);
  }

  
  DeleteNote3(id: any, note: any) {
    const payload = {
      userId: localStorage.getItem('CurrentuserID'),
      centralUserId: localStorage.getItem('CentralUserId'),
      financialPeriodsID: localStorage.getItem('currentPeriod'),
      note: note,
      id: id?.toString()
    }
    const url = `${this.apiUrl}/Note1to10/DeleteNote3Details`;
    return this.http.post(url, payload);
  }
  saveNote8AgentFundsDetails(Note8details: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNote8AgentFundsDetails`;
    return this.http.post(url, Note8details);
  }
  saveNote8ConsortiaArrangements(Note8details: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/saveNote8ConsortiaArrangements`;
    return this.http.post(url, Note8details);
  }
  saveNote25Details(Note22details: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote25Details`;
    return this.http.post(url, Note22details);
  }
  saveNote26Details(Note22details: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote26Details`;
    return this.http.post(url, Note22details);
  }
  saveNote22Details(Note22details: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote22Details`;
    return this.http.post(url, Note22details);
  }
  saveNote21Details(Note21details: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote21Details`;
    return this.http.post(url, Note21details);
  }
  saveNote21addtional(Note21aditional: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote21additonalDetails`;
    return this.http.post(url, Note21aditional);
  }

  saveNote23(note23: any, tab: string, id: number, action: string): Observable<any> {

    //this.http.post(url, JSON.stringify(payload), {
    //  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    //});
    const url = `${this.apiUrl}/Note21to30/saveNote23`;
    const payload = {
     note23: note23,
      //ThisYearData: note23.ThisYearData,
      //LastYearData: note23.LastYearData,
      tab: tab,
      id: id,
      action: action
    };

    return this.http.post(url, payload, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });

    //return this.http.post(url, Note23, tab);
  }
  deleteNote23wizard1(id: any): Observable<any> {
    const url = `${this.apiUrl}/Note21to30/deleteNote23wizard1?id=${id}`;
    return this.http.delete(url);
  }
  deleteNote23wizard3(id: any): Observable<any> {
    const url = `${this.apiUrl}/Note21to30/deleteNote23wizard3?id=${id}`;
    return this.http.delete(url);
  }
  saveNote23page3(Note23page3: any, action: string, charityID: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote23page3?action=${action}&charityid=${charityID}`;
    return this.http.post(url, Note23page3);
  }
  GetNote23page3(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/GetNote23page3?id=`;
    return this.http.get(url + id);
  }
  GetNotes23(financialPeriodsID: number, tabType: string): Observable<any> {
    const url = `${this.apiUrl}/Note21to30/GetNotes23?FinancialPeriodsID=${financialPeriodsID}&TabType=${encodeURIComponent(tabType)}`;
    return this.http.get<any>(url);
  }
  saveNote29Details(Note22details: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote29Details`;
    return this.http.post(url, Note22details);
  }
  GetNote22Details(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/GetNote22Details?id=`;
    return this.http.get(url + id);
  }
  GetNote21Details(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/GetNote21Details?id=`;
    return this.http.get(url + id);
  }
  GetNote21additional(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/GetNote21additional?id=`;
    return this.http.get(url + id);
  }
  GetNote25Details(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/GetNote25Details?id=`;
    return this.http.get(url + id);
  }
  GetNote26Details(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/GetNote26Details?id=`;
    return this.http.get(url + id);
  }
  GetNote29Details(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/GetNote29Details?id=`;
    return this.http.get(url + id);
  }
  GetNote8AgentFundsDetails(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote8AgentFundsDetails?id=`;
    return this.http.get(url + id);
  }
  GetNote8ConsortiaArrangements(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote8ConsortiaArrangements?id=`;
    return this.http.get(url + id);
  }

  SaveNotes7(model: Note7model): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes7`;
    return this.http.post<Note7model>(url, model);
  }

  GetNotes7(PeriodID: any, UserId: any, CentralUser: any, charityId: any): Observable<any> {

    const url = this.apiUrl + '/Note1to10/GetNotes7?PeriodID=' + PeriodID + '&UserId=' + UserId + '&CentralUser=' + CentralUser + '&charityId=' + charityId + ''
    return this.http.get(url);
  }

  DeleteNotes7(fID: number, noteID: number): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/DeleteNotes7?fID=${fID}&noteID=${noteID}`;
    return this.http.delete(url);
  }

  SaveNotes24(model: Note24model): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote24`;
    return this.http.post<Note24model>(url, model);
  }

  GetNotes24(fID: any, cID: any): Observable<any> {

    const url = this.apiUrl + '/Note21to30/GetNote24?fID=' + +fID + '&cID=' + +cID + ''
    return this.http.get(url);
  }


  SaveNotes19(model: Note19model, page: any): Observable<any> {

    if (page == 'Analysis') {
      const url = `${this.apiUrl}/Note11to20/SaveNotes19_A`;
      return this.http.post<Note24model>(url, model);
    } else {
      const url = `${this.apiUrl}/Note11to20/SaveNotes19_B`;
      return this.http.post<Note24model>(url, model);
    }
  }

  GetNotes19(fID: any, cID: any, page: any): Observable<any> {

    if (page == 'Analysis') {
      const url = this.apiUrl + '/Note11to20/GetNotes19_A?fID=' + +fID + '&cID=' + +cID + ''
      return this.http.get(url);
    } else {
      const url = this.apiUrl + '/Note11to20/GetNotes19_B?fID=' + +fID + '&cID=' + +cID + ''
      return this.http.get(url);
    }
  }
  saveNote28Tab1(Note28details: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote28TrusteeRemuneration`;
    return this.http.post(url, Note28details);
  }
  GetNote28Tab1(id: any): Observable<any> {

    const url = this.apiUrl + '/Note21to30/GetNote28TrusteeRemuneration?id=' + id
    return this.http.get(url);
  }
  saveNote28Tab2(Note28details: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote28TrusteeExpenses`;
    return this.http.post(url, Note28details);
  }

  GetNote28Tab2(id: any): Observable<any> {

    const url = this.apiUrl + '/Note21to30/GetNote28TrusteeExpenses?id=' + id
    return this.http.get(url);
  }
  saveNote28Tab3(Note28details: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote28TrusteeTransactions`;
    return this.http.post(url, Note28details);
  }
  GetNote28Tab3(id: any): Observable<any> {

    const url = this.apiUrl + '/Note21to30/GetNote28TrusteeTransactions?id=' + id
    return this.http.get(url);
  }
  GetTrustees(id: any): Observable<any> {

    const url = this.apiUrl + '/Note21to30/GetTrustees?id=' + id
    return this.http.get(url);
  }
  GetNote14Page1(id: any): Observable<any> {

    const url = this.apiUrl + '/Note11to20/GetNote14Page1?id=' + id
    return this.http.get(url);
  }
  GetNote14Page2(id: any): Observable<any> {

    const url = this.apiUrl + '/Note11to20/GetNote14Page2?id=' + id
    return this.http.get(url);
  }
  GetNote14Page3(id: any): Observable<any> {

    const url = this.apiUrl + '/Note11to20/GetNote14Page3?id=' + id
    return this.http.get(url);
  }

  GetNote14Page4(id: any): Observable<any> {

    const url = this.apiUrl + '/Note11to20/GetNote14Page4?id=' + id
    return this.http.get(url);
  }
  GetNote14Page5(id: any): Observable<any> {

    const url = this.apiUrl + '/Note11to20/GetNote14Page5?id=' + id
    return this.http.get(url);
  }
  GetNote14Page6(id: any): Observable<any> {

    const url = this.apiUrl + '/Note11to20/GetNote14Page6?id=' + id
    return this.http.get(url);
  }

  SaveNote11Details(Note11details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes11`;
    return this.http.post(url, Note11details);
  }
  SaveNote14Details(Note14details: any, action: string): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes14`;
    const payload = {
      userId: localStorage.getItem('CurrentuserID'),
      centralUserId: localStorage.getItem('CentralUserId'),
      financialPeriodsID: localStorage.getItem('currentPeriod'),
      charityID: +localStorage.getItem('currentCharityID')!,
      SaveType: action,
      note14Details: Note14details
    };
    return this.http.post(url, payload);
  }
  SaveNote14page2(Note14page2: any, action: string): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes14page2`;
    const payload = {
      userId: localStorage.getItem('CurrentuserID'),
      centralUserId: localStorage.getItem('CentralUserId'),
      financialPeriodsID: localStorage.getItem('currentPeriod'),
      charityID: +localStorage.getItem('currentCharityID')!,
      SaveType: action,
      note14page2: Note14page2
    };
    return this.http.post(url, payload);
  }

  SaveNote14page3(Note14page3: any, action: string): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes14page3`;
    const payload = {
      userId: localStorage.getItem('CurrentuserID'),
      centralUserId: localStorage.getItem('CentralUserId'),
      financialPeriodsID: localStorage.getItem('currentPeriod'),
      charityID: +localStorage.getItem('currentCharityID')!,
      SaveType: action,
      note14page3: Note14page3
    };
    return this.http.post(url, payload);
  }
  SaveNote14page4(Note14page4: any, action: string): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes14page4?action=${action}`;
    return this.http.post(url, Note14page4);
  }
  SaveNote14page5(Note14page5: any, action: string): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes14page5?action=${action}`;
    return this.http.post(url, Note14page5);
  }
  SaveNote14page6(Note14page6: any, action: string): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes14page6?action=${action}`;
    return this.http.post(url, Note14page6);
  }

  FetchNote11(FinPeriodID: any, Wizardtype: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/FetchNotes11?FinPeriodID=${FinPeriodID}&Wizardtype=${Wizardtype}`;
    return this.http.get(url);
  }
  SaveNote16(Note16details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes16`;
    return this.http.post(url, Note16details);
  }
  SaveNote16Wizard6(Note16Wiz6: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote16Wizardsix`;
    return this.http.post(url, Note16Wiz6);
  }
  GetNote16Wizard1and5(FinPeriodID: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNotes16WizardOneandFive?FinPeriodID=`;
    return this.http.get(url + FinPeriodID);
  }
  GetNote16WizardSix(FinPeriodID: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNotes16WizardSix?FinPeriodID=`;
    return this.http.get(url + FinPeriodID);
  }
  GetNote16WizardSeven(FinPeriodID: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNotes16WizardSeven?FinPeriodID=`;
    return this.http.get(url + FinPeriodID);
  }
  GetNote16WizardEight(FinPeriodID: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNotes16WizardEight?FinPeriodID=`;
    return this.http.get(url + FinPeriodID);
  }
  GetNote16WizardNine(FinPeriodID: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote16WizardNine?FinPeriodID=`;
    return this.http.get(url + FinPeriodID);
  }
  GetNote16WizardTwo(FinPeriodID: any, WizardType: any,): Observable<any> {

    //const url = `${this.apiUrl}/Note11to20/GetNotes16WizardTwo?FinPeriodID=`;
    const url = `${this.apiUrl}/Note11to20/GetNotes16WizardTwo?FinPeriodID=${FinPeriodID}&Wizardtype=${WizardType}`;
    return this.http.get(url);
  }
  SaveNote16Wizard8(Note16Wiz8: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote16Wizardeight`;
    return this.http.post(url, Note16Wiz8);
  }
  SaveNote16Wizard9(Note16Wiz9: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote16WizardNine`;
    return this.http.post(url, Note16Wiz9);
  }
  SaveNote16Wizard7(Note16Wiz7: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote16Wizardseven`;
    return this.http.post(url, Note16Wiz7);
  }
  SaveNotes16Wizard2(Note16data: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes16Wizardtwo`;
    return this.http.post(url, Note16data);
  }
  SaveNotes10(model: Note10model): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/SaveNotes10`;
    return this.http.post<Note10model>(url, model);
  }

  GetNotes10(PeriodID: any, UserId: any, CentralUser: any, charityId: any): Observable<any> {

    const url = this.apiUrl + '/Note1to10/GetNotes10?PeriodID=' + PeriodID + '&UserId=' + UserId + '&CentralUser=' + CentralUser + '&charityId=' + charityId + ''
    return this.http.get(url);
  }

  DeleteNotes10(fID: number, noteID: number): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/DeleteNotes10?fID=${fID}&noteID=${noteID}`;
    return this.http.delete(url);
  }
  saveNote13_A(SaveNotes13_A: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes13_A`;
    return this.http.post(url, SaveNotes13_A);
  }
  GetNote13_A(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote13_A?id=`;
    return this.http.get(url + id);
  }
  GetNote13_ALY(charityid: any, id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote13_ALY?charityid=` + charityid + '&id=' + id;
    return this.http.get(url);
  }
  DeleteNote13_A(GrantsPaidID: any, id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/DeleteNote13_A?GrantsPaidID=` + GrantsPaidID + '&id=' + id;
    return this.http.get(url);
  }
  saveNote13_B(SaveNotes13_B: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes13_B`;
    return this.http.post(url, SaveNotes13_B);
  }
  GetNote13_B(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote13_B?id=`;
    return this.http.get(url + id);
  }
  GetNote13_BLY(charityid: any, APid: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote13_BLY?charityid=` + charityid + '&aPid=' + APid;
    return this.http.get(url);
  }
  deletenote13wizard(id: any): Observable<any> {
    const url = `${this.apiUrl}/Note11to20/deletenote13wizard?id=${id}`;
    return this.http.delete(url);
  }
  deletenote13allwizard(id: any): Observable<any> {
    const url = `${this.apiUrl}/Note11to20/deletenote13allwizard?id=${id}`;
    return this.http.delete(url);
  }
  savenote3otherinformation(model: any) {

    const url = `${this.apiUrl}/Note1to10/SaveNote3OtherInformation`;
    return this.http.post<Note7model>(url, model);
  }
  savenote30(model: any) {
    debugger
    const url = `${this.apiUrl}/Note21to30/saveNote30`;
    return this.http.post<Note30model>(url, model);
  }

  getnote30(FinancialPeriodsID: number): Observable<Note30model[]> {
    const url = `${this.apiUrl}/Note21to30/getNote30?FinancialPeriodsID=${FinancialPeriodsID}`;
    return this.http.get<Note30model[]>(url);
  }

  savenote3Note17(model: any) {

    const url = `${this.apiUrl}/Note11to20/SaveNote3Note17`;
    return this.http.post<any>(url, model);
  }

  SaveGuaranteesNote17(model: any) {

    const url = `${this.apiUrl}/Note11to20/SaveGuaranteesNote17`;
    return this.http.post<any>(url, model);
  }
  ConcessionaryloansSave(model: any) {

    const url = `${this.apiUrl}/Note11to20/ConcessionaryloansNote17`;
    return this.http.post<any>(url, model);
  }
  SaveAdditionalInforNote17(model: any) {

    const url = `${this.apiUrl}/Note11to20/SaveAdditionalInfo17`;
    return this.http.post<any>(url, model);
  }


  Getnote3otherinformation(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/GetNote3OtherInformation?id=`;
    return this.http.get(url + id);
  }
  Getnote17thirdTab(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote17thirdtab?id=`;
    return this.http.get(url + id);
  }

  GuaranteesGetnote17(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GuaranteesGetNote17?id=`;
    return this.http.get(url + id);
  }
  GetAdditionalinfo17(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetAdditionalinfo17?id=`;
    return this.http.get(url + id);
  }
  GetConcessionaryloans(financialPeriodsID: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetConcessionaryloansNote17?financialPeriodsID=`;
    return this.http.get(url + financialPeriodsID);
  }
  saveNote15Tab1(Note15details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote15Tab1`;
    return this.http.post(url, Note15details);
  }
  saveNote15Tab2(Note15details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote15Tab2`;
    return this.http.post(url, Note15details);
  }
  saveNote15Tab3(Note15details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote15Tab3`;
    return this.http.post(url, Note15details);
  }
  saveNote15Tab4(Note15details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote15Tab4`;
    return this.http.post(url, Note15details);
  }
  saveNote15Tab5(Note15details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote15Tab5`;
    return this.http.post(url, Note15details);
  }
  saveNote15Tab6(Note15details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote15Tab6`;
    return this.http.post(url, Note15details);
  }
  saveNote15Tab7(Note15details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNote15Tab7`;
    return this.http.post(url, Note15details);
  }
  GetNote15Tab1(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote15Tab1?id=`;
    return this.http.get(url + id);
  }
  GetNote15Tab2(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote15Tab2?id=`;
    return this.http.get(url + id);
  }
  GetNote15Tab7(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote15Tab7?id=`;
    return this.http.get(url + id);
  }
  GetNote15Tab3(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote15Tab3?id=`;
    return this.http.get(url + id);
  }
  GetNote15Tab4(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote15Tab4?id=`;
    return this.http.get(url + id);
  }
  GetNote15Tab5(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote15Tab5?id=`;
    return this.http.get(url + id);
  }
  GetNote15Tab6(id: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/GetNote15Tab6?id=`;
    return this.http.get(url + id);
  }
  SaveNotes27(payload: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/saveNote27`;
    return this.http.post<Note27model>(url, payload);
  }
  SaveNotes27page3(payload: any): Observable<any> {

    const url = `${this.apiUrl}/Note21to30/SaveNotes27page3`;
    return this.http.post<Notes27page3>(url, payload);
  }


  GetNotes27(fID: any, cID: any, flag: any): Observable<any> {

    const url = this.apiUrl + '/Note21to30/GetNote27?fID=' + +fID + '&cID=' + +cID + '' + '&flag=' + flag
    return this.http.get(url);
  }
  GetNotes27page3(fID: any, cID: any): Observable<any> {

    const url = this.apiUrl + '/Note21to30/GetNotes27page3?fID=' + +fID + '&cID=' + +cID + ''
    return this.http.get(url);
  }
  getCurrencies(): Observable<CurrencyResponse> {

    return this.http.get<CurrencyResponse>(this.currencyApiUrl);
  }


  SaveNote20Wizard1(Note20details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes20Wizardone`;
    return this.http.post(url, Note20details);
  }

  SaveNote20Wizard2(Note20details: any): Observable<any> {

    const url = `${this.apiUrl}/Note11to20/SaveNotes20WizardTwo`;
    return this.http.post(url, Note20details);
  }
  Getnote20WizardOne(id: any): Observable<any> {

    const url = this.apiUrl + '/Note11to20/GetNotes20Wizardone?id=' + id
    return this.http.get(url);
  }
  Getnote20WizardTwo(id: any): Observable<any> {

    const url = this.apiUrl + '/Note11to20/GetNotes20WizardTwo?id=' + id
    return this.http.get(url);
  }
  saveNote9(Note9details: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Note1to10/saveNote9Details`;
    return this.http.post(url, Note9details);
  }
  GetNote9(id: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Note1to10/GetNote9Details?id=`;
    return this.http.get(url + id);
  }

  DeleteNote8Tab1(id: any, FinancialPeriodsIDs: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/DeleteNote8Tab1?id=${id}&FinancialPeriodsIDs=${FinancialPeriodsIDs}`;
    return this.http.delete(url);
  }
  DeleteNote8Tab2(id: any, FinancialPeriodsIDs: any): Observable<any> {

    const url = `${this.apiUrl}/Note1to10/DeleteNote8Tab2?id=${id}&FinancialPeriodsIDs=${FinancialPeriodsIDs}`;
    return this.http.delete(url);
  }

}
